import { FILTER_USERS_COMMUNITY } from 'shared/providers/redux/actionTypes';

export const setFilterUserCommunity = filter => {
  return {
    type: FILTER_USERS_COMMUNITY,
    payload: filter,
  };
};
